import { Component, PropTypes } from 'react';
import Sticky from 'react-stickydiv';
import cx from 'classnames';
import { triggerScroll } from 'utils';
import styles from './styles.css';

export default class Aside extends Component {
	static propTypes = {
		isShown: PropTypes.bool.isRequired,
		onCloseClick: PropTypes.func.isRequired,
		title: PropTypes.string,
		text: PropTypes.string,
		gallery: PropTypes.shape({
			link: PropTypes.string,
			images: PropTypes.arrayOf(PropTypes.string)
		})
	}

	componentDidMount() {
		triggerScroll();
	}

	renderContent() {
		const { title, text, gallery } = this.props;

		return (
			<Sticky>
				<div className={styles.content}>
					<div className={styles.close} onClick={this.props.onCloseClick} />

					<div className={styles.title}>{title}</div>
					<div className={styles.text}>{text}</div>

					<a href={gallery.link}>
						<div className={styles.images}>
							{gallery.images.map((image, index) =>
								<img key={index} className={styles.image} src={require(`./images/${image}`)} />
							)}
						</div>

						<div className={styles.link}>{gallery.link.replace(/https?:\/\/(www\.)?/, '')}</div>
					</a>
				</div>
			</Sticky>
		);
	}

	render() {
		const className = cx(styles.aside, {
			[styles.isShown]: this.props.isShown,
			[styles.isHidden]: !this.props.isShown
		});

		return (
			<div ref="aside" className={className}>
				{this.props.isShown
					&& this.renderContent()}
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./components/Aside/index.js
 **/